import React from "react";
import classNames from "classnames";

const Container = ({
  outerContainerClassName,
  innerContainerClassName,
  additionalPx = false,
  children,
  id,
}) => {
  return (
    <div
      className={classNames(
        "relative w-full overflow-hidden z-0 pt-0 md:pt-46px pb-46px",
        outerContainerClassName
      )}
      id={id}
    >
      <div
        className={classNames("w-full mx-auto", innerContainerClassName, {
          "px-32px": !additionalPx,
          "px-32px md:px-64px": additionalPx,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default Container;
